"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../../hooks");
var _Avatar = require("../../../../UI/Avatar");
var _Button = require("../../../../UI/Button");
var _Menu = require("../../../../UI/Menu");
var _List = require("../../../../Data/List");
var _ListItem = require("../../../../Data/List/partials/ListItem");
var _UserRoles = require("./UserRoles");
var _Header = require("../Header.labels");
var _Header2 = _interopRequireDefault(require("../Header.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Profile = function Profile(props) {
  var _user$gender;
  var isMobileView = props.isMobileView,
    lang = props.lang,
    user = props.user,
    avatarUrl = props.avatarUrl,
    onShowProfileClick = props.onShowProfileClick,
    _props$avatarSize = props.avatarSize,
    avatarSize = _props$avatarSize === void 0 ? 'small' : _props$avatarSize;
  var _useCetEvents = (0, _hooks.useCetEvents)(),
    sendUiUsageEvent = _useCetEvents.sendUiUsageEvent;
  var getLabel = (0, _hooks.useLabels)({
    labels: _Header.labels
  });
  var styles = (0, _Header2.default)(isMobileView, !Boolean(user === null || user === void 0 ? void 0 : user.userId));
  var menuRef = (0, _react.useRef)(null);
  var handleLogout = function handleLogout() {
    window.cet.accessmanagement.logout("".concat(window.location.origin, "/").concat(lang));
    var categoryName = 'upperToolbar';
    var labelName = 'logout';
    sendUiUsageEvent({
      category: categoryName,
      label: labelName
    });
  };
  if (!(user !== null && user !== void 0 && user.userId)) return null;
  var avatar = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
    avatarUrl: avatarUrl !== null && avatarUrl !== void 0 ? avatarUrl : user === null || user === void 0 ? void 0 : user.userAvatarUrl,
    firstName: user === null || user === void 0 ? void 0 : user.firstName,
    lastName: user === null || user === void 0 ? void 0 : user.lastName,
    gender: (_user$gender = user === null || user === void 0 ? void 0 : user.gender) !== null && _user$gender !== void 0 ? _user$gender : 'male',
    size: avatarSize,
    withDefaultImage: true,
    ariaHidden: true
  });
  var btnProps = {
    view: 'alternate',
    color: 'basic',
    shape: 'roundedRectangle',
    customStyle: {
      paddingInline: 6
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [avatar, /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: styles['cc-Header__toolbar__profile__button'],
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-Header__toolbar__profile__button__name'],
          children: user === null || user === void 0 ? void 0 : user.firstName
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserRoles.UserRoles, {
          isMobileView: isMobileView,
          lang: lang,
          user: user
        })]
      })]
    }),
    ariaLabel: "".concat(getLabel('view_my_profile'), " ").concat(user === null || user === void 0 ? void 0 : user.firstName)
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    children: isMobileView ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      id: "ccHeaderProfileButton",
      ariaLabel: getLabel('view_my_profile'),
      onClick: onShowProfileClick,
      category: "upperToolbar",
      label: "showMyProfile",
      shape: "round",
      color: "basic",
      view: "text",
      children: avatar
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Menu.Menu, {
      btnProps: btnProps,
      ref: menuRef,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Header__profile-popup__title'],
        children: user === null || user === void 0 ? void 0 : user.displayName
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_List.List, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItem.ListItem, {
          id: "profile-view",
          size: "small",
          onClick: function onClick(id) {
            var _menuRef$current;
            onShowProfileClick();
            (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.closeMenu();
          },
          children: getLabel('view_my_profile')
        }), user.hasMultipleRoles && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItem.ListItem, {
          id: "ccHeaderUserRolesButton",
          size: "small",
          color: "basic",
          onClick: function onClick() {
            window.cet.accessmanagement.changeRole(window.location.href, null, lang);
          },
          children: getLabel('change_user_role')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItem.ListItem, {
          id: "profile-logout",
          size: "small",
          onClick: handleLogout,
          children: getLabel('logout')
        })]
      })]
    })
  });
};
exports.Profile = Profile;